import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { AutocompleteItem, AutocompleteTextInput } from '../../AutocompleteTextInput';
import { FormContext } from '../Form';
import { FormField, InputAndErrorContainer } from '../FormField';

type Props<TItem extends AutocompleteItem> = {
  autocompleteItems: Array<TItem>;
  name: string;
  label: string | null;
  onSelect?: (selectedItem: TItem) => void;
};

export const AutocompleteTextInputField = <TItem extends AutocompleteItem>({
  autocompleteItems,
  name,
  label,
  onSelect,
}: Props<TItem>) => {
  const formIsDisabled = useContext(FormContext).isDisabled;

  return (
    <FormField name={name} label={label}>
      {({ form, field, $isValid, $isInvalid }) => {
        return (
          <Container>
            <AutocompleteTextInput
              {...field}
              autocompleteItems={autocompleteItems}
              onSelect={selectedItem => {
                if (selectedItem != null) {
                  form.setFieldValue(field.name, selectedItem.displayText);
                  if (onSelect != null) {
                    onSelect(selectedItem);
                  }
                }
              }}
              onChange={(newValue: string) => form.setFieldValue(field.name, newValue)}
              onBlur={() => form.setFieldTouched(field.name, true)}
              $isValid={$isValid}
              $isInvalid={$isInvalid}
              disabled={form.isSubmitting || formIsDisabled}
            />
          </Container>
        );
      }}
    </FormField>
  );
};

const Container = styled.div`
  width: 100%;

  ${InputAndErrorContainer}: {
    position: relative;
    z-index: 0;
  };
`;
